import {
	COUNTIES,
	FORMATS,
	REGIONS,
	STORES,
	VENDORS,
	BRANDS,
	PRODUCTS,
	CATEGORIES,
	SUBCATEGORIES,
	DEPARTMENTS,
	AGE,
	SEGMENTATION,
	GENDER,
	CHANNEL,
	PSYCHOGRAPHICS,
	FINELINES,
	CUSTOMER_TYPE,
} from "components/Shared/GlobalFilter/constants"
import moment from "moment"
import { ModuleState } from "./interfaces"
import { COLOR_PALETTE } from "colors"

const today = moment().subtract(3, "days")
const firstOfYear = moment().startOf("year")

export const INTERVAL_DEFAULT = [
	{
		id: "currentDate",
		startDate: firstOfYear.toDate(),
		endDate: today.toDate(),
		color: COLOR_PALETTE.PURPLE_600,
		secondaryColor: COLOR_PALETTE.PURPLE_100,
		label: "phronesis.rangecalendar.current.date",
	},
	{
		id: "previousDate",
		startDate: firstOfYear.subtract(1, "years").toDate(),
		endDate: today.subtract(1, "years").toDate(),
		color: COLOR_PALETTE.YELLOW_600,
		secondaryColor: COLOR_PALETTE.YELLOW_100,
		label: "phronesis.rangecalendar.previous.date",
	},
]

export const FILTERS_DEFAULT_STATE = {
	[REGIONS]: [],
	[COUNTIES]: [],
	[STORES]: [],
	[FORMATS]: [],
	[VENDORS]: [],
	[BRANDS]: [],
	[PRODUCTS]: [],
	[DEPARTMENTS]: [],
	[CATEGORIES]: [],
	[SUBCATEGORIES]: [],
	[AGE]: [],
	[SEGMENTATION]: [],
	[GENDER]: [],
	[CHANNEL]: [],
	[PSYCHOGRAPHICS]: [],
	[FINELINES]: [],
	[CUSTOMER_TYPE]: [],
}

export const MODULE_STATE_DEFAULT: ModuleState = {
	transactional: {
		benchmark: {
			metric: "sales",
		},
		penetration: {
			metric: "total",
			summary: "clients",
			timeline: "clients",
		},
	},
}
